const colors = {
  PRIMARY: `#08C2F3`,
  PRIMARY_DARK: `#06A6D1`,
  BLACK: "#000000",
  WHITE: "#FFFFFF",
  GREY: "#C6C3C3",
  GREY_100: "#F2F4F7",
  GREY_200: "#EAECF0",
  GREY_300: "#D0D5DD",
  GREY_400: "#98A2B3",
  GREY_500: "#667085",
  GREY_600: "#475467",
  DARK_GREEN: "#004050",
  BLUE_100: "#F5FDFF",
  BLUE_200: "#E6F9FE",
  BLUE_300: "#B5EEFD",
  BLUE_400: "#84E2FB",
  BLUE_500: "#08C2F3",
  BLUE_600: "#06A6D1",
  DANGER_100: "#FDDCDD",
  ERROR: "#BA000D",
  DANGER_600: "#CA4146",
  WARNING_600: "#FF8800",
  WARNING_100: "#FAF2E8",
  SUCCESS_600: "#067647",
  SUCCESS_100: "#ABEFC6",
  success_50: "#ECFDF3",

  
};

export default colors;
